import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    Optional,
    QueryList,
    Renderer2,
    Self,
    ViewChildren,
} from "@angular/core";
import { NgControl } from "@angular/forms";

import { DATE_FORMAT } from "../../tokens/date-format.token";
import { SpsDateRangePickerComponent } from "../datepicker/range/sps-date-range-picker.component";
import { SpsTimeInputComponent } from "../time-input/sps-time-input.component";

@Component({
    selector: "sps-datetime-range-picker",
    templateUrl: "./sps-datetime-range-picker.component.html",
})
export class SpsDatetimeRangePickerComponent extends SpsDateRangePickerComponent
implements AfterViewInit {
    static readonly displayName = "sps-datetime-range-picker";
    static readonly props = {
        ...SpsDateRangePickerComponent.props,
    };

    startText: string;
    endText: string;

    get start() {
        return this.value ? this.value.start : null;
    }
    set start(value) {
        if (this.value) {
            this.value.start = value;
        } else {
            this.value = {
                start: value,
                end: null,
            };
        }
    }

    get end() {
        return this.value ? this.value.end : null;
    }
    set end(value) {
        if (this.value) {
            this.value.end = value;
        } else {
            this.value = {
                start: null,
                end: value,
            };
        }
    }

    @ViewChildren(SpsTimeInputComponent) timeInputs: QueryList<SpsTimeInputComponent>;

    constructor(
        _changeDetector: ChangeDetectorRef,
        @Inject(DATE_FORMAT) _dateFormat: string,
        _el: ElementRef,
        _renderer: Renderer2,
        @Self()
        @Optional()
        _ngControl: NgControl
    ) {
        super(_changeDetector, _dateFormat, _el, _renderer, _ngControl);
        this.placeholder = this.formatString;
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => this.timeInputs.forEach(input => input.disableClearing()), 0);
    }

    updateText() {
        super.updateText();
        [this.startText, this.endText] = this.text.split(" - ");
    }

    onTimeChange() {
        this._changeDetector.markForCheck();
    }

    clear() {
        super.clear();
        this._changeDetector.markForCheck();
    }
}
